import { render, staticRenderFns } from "./Infographics.vue?vue&type=template&id=aad38064"
import script from "./Infographics.vue?vue&type=script&lang=js"
export * from "./Infographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports